import { globalStyleObj } from "@/app/assets/styles";
import {
  LabelText,
  NormalBrowseFileInputFiled,
  NormalTextInputField,
} from "@/components";
import { Skeleton } from "@/components/ui/skeleton";
import React, { useMemo } from "react";
import { MdClose, MdOutlineDeleteForever } from "react-icons/md";

const HomePartnersSectionFormField = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  addOnlyValueRepeaterChange,
  removeOnlyValueRepeaterChange,
  updateOnlyValueRepeaterChange,
  stateDetails,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeLang === "en";
  }, [activeLang]);

  // Update Entry
  const updateImageId = (id, index) => {
    if (id) {
      updateOnlyValueRepeaterChange(
        "home_section_4_partners_images",
        index,
        id
      );
    } else {
      updateOnlyValueRepeaterChange(
        "home_section_4_partners_images",
        index,
        ""
      );
    }
  };

  // Remove Entry
  const removeImageId = (index) => {
    removeOnlyValueRepeaterChange("home_section_4_partners_images", index);
  };

  // Add Entry
  const addNewEntry = () => {
    addOnlyValueRepeaterChange("home_section_4_partners_images");
  };

  // Section Bg Image
  const getImageId = (id) => {
    if (id) {
      onChangeImage("home-section-4-partners-bg-image", id);
    } else {
      onChangeImage("home-section-4-partners-bg-image", "");
    }
  };

  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-4-partners-heading"
        fieldName="home-section-4-partners-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-4-partners-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />

      {/* Partner Section Background Image */}
      {isHideInOtherLanguages && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText="Background Image"
          fieldId="home-section-4-partners-bg-image"
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={getImageId}
          selectedFileId={
            stateDetails?.["home-section-4-partners-bg-image"] || ""
          }
          adminRole={adminRole}
          permissionsList={permissionsList}
          extraContainerClasses="mt-5"
        />
      )}

      {/* Partner Images */}
      {isHideInOtherLanguages && (
        <div className="w-full mt-5 flex flex-col gap-2 xl:flex-row justify-between lg:gap-5">
          {isFetching ? (
            <Skeleton className="w-[150px] h-[30px] rounded-md" />
          ) : (
            <LabelText
              text="Partner Images"
              htmlForId="home-section-4-partners-images"
              star={false}
              translateField={false}
            />
          )}

          <div className="w-full lg:max-w-[500px]">
            {stateDetails?.["home_section_4_partners_images"] &&
              stateDetails?.["home_section_4_partners_images"].length > 0 && (
                <div className="w-full">
                  {stateDetails?.["home_section_4_partners_images"].map(
                    (item, index) => (
                      <div key={index} className="w-full flex gap-2 mb-5">
                        {isFetching ? (
                          <Skeleton className="w-full flex-1 h-[40px] rounded-md" />
                        ) : (
                          <NormalBrowseFileInputFiled
                            isFetching={isFetching}
                            fieldId="home-section-2-about-company-image"
                            allFilesResponse={allFilesResponse}
                            searchValue={searchValue}
                            selectedFileType={selectedFileType}
                            onChangeImageFunction={(id) =>
                              updateImageId(id, index)
                            }
                            selectedFileId={
                              stateDetails?.[
                                "home_section_4_partners_images"
                              ]?.[index] || ""
                            }
                            adminRole={adminRole}
                            permissionsList={permissionsList}
                            extraContainerClasses="flex-1"
                          />
                        )}

                        {isFetching ? (
                          <Skeleton className="w-[30pxpx] h-[40px] rounded-md" />
                        ) : (
                          <button
                            type="button"
                            onClick={() => removeImageId(index)}
                            className="flex justify-center items-start"
                          >
                            <MdOutlineDeleteForever
                              size={25}
                              className="text-red-500 hover:scale-[1.2] transition-300"
                            />
                          </button>
                        )}
                      </div>
                    )
                  )}
                </div>
              )}

            {isFetching ? (
              <Skeleton className="w-[120px] h-[40px] rounded-md" />
            ) : (
              <button
                type="button"
                onClick={() => addNewEntry()}
                className={`${globalStyleObj.flexCenter} transition-300 gap-2 rounded-[4px] ${colorGrade.bgColor} ${colorGrade.hoverBgColor} ${colorGrade.textColor} px-5 py-2 font-poppins-rg text-[13px] tracking-wide hover:text-white w-full sm:max-w-[120px] dark:text-light-weight-800`}
              >
                Add
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default HomePartnersSectionFormField;
